import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      d="M6.76925 5.00065L9.42263 2.34728C9.74823 2.02167 9.74823 1.49376 9.42263 1.16789L8.83293 0.578189C8.50732 0.252583 7.97941 0.252583 7.65353 0.578189L5.00016 3.23156L2.34679 0.578189C2.02119 0.252583 1.49327 0.252583 1.1674 0.578189L0.577701 1.16789C0.252095 1.49349 0.252095 2.02141 0.577701 2.34728L3.23107 5.00065L0.577701 7.65402C0.252095 7.97963 0.252095 8.50755 0.577701 8.83342L1.1674 9.42311C1.493 9.74872 2.02119 9.74872 2.34679 9.42311L5.00016 6.76974L7.65353 9.42311C7.97914 9.74872 8.50732 9.74872 8.83293 9.42311L9.42263 8.83342C9.74823 8.50781 9.74823 7.97989 9.42263 7.65402L6.76925 5.00065Z"
      fill="#999999"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const CloseIcon = memo(ForwardRef);
export default CloseIcon;
